import { MenuModes, MenuActions } from './../../../../../providers/menu-entries.service';
import { NavController } from 'ionic-angular';
import { TakeSelfiePage } from './take-selfie/take-selfie';
import { Component, ViewChild } from '@angular/core';
import { ViewController, NavParams } from 'ionic-angular';
import { TranslateService } from '@ngx-translate/core';
import { ConfigProvider } from '../../../../../providers/config/config';
import { AppDetectorProvider } from '../../../../../providers/detector/detector';
import { ActivityFriendsPage } from '../../../../event/event-activity-tabs/activity-friends/activity-friends';
import { EventProvider } from '../../../../../providers/event/event';
import { ThemeMode } from '../../../../../providers/dark-mode/dark-mode';


/**
 * 
 */

@Component({
    templateUrl: 'mysport-results-menu.html',
    selector: 'mysport-results-menu'
})
export class MysportResultsMenuPage {
    mode: string = "public";
    spooorts: boolean = false;
    feeds:any;
    themeMode;
    

    constructor(public viewCtrl: ViewController,
        public translate: TranslateService,
        private navParams: NavParams,
        public appDetector: AppDetectorProvider,
        private config: ConfigProvider,
        public navCtrl: NavController,
        public eventService:EventProvider) {
        new Promise<any>(async (resolve, reject) => {
            this.spooorts = (await this.config.config).appId.includes("com.spooorts.event") ? true : false;
        });
        this.themeMode = JSON.parse(localStorage.getItem('darkMode') || `"${ThemeMode.LightMode}"`) as ThemeMode;
        console.log('theme', this.themeMode)

    }

    ionViewWillEnter() {
        this.mode = this.navParams.get('mode');
    }

    dismiss(option) {
        this.viewCtrl.dismiss(option);
    }

    public get getMenuMode(): typeof MenuModes{
        return MenuModes;
    }

    public get getMenuAction(): typeof MenuActions{
        return MenuActions;
    }
}




// WEBPACK FOOTER //
// /src/pages/me/mysport/mysport-results/mysport-results-menu/mysport-relults-menu.ts